import { render, staticRenderFns } from "./besttable.vue?vue&type=template&id=00cafc27&scoped=true&"
import script from "./besttable.vue?vue&type=script&lang=js&"
export * from "./besttable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cafc27",
  null
  
)

export default component.exports